function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_776_529)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.396484,
  width: 32,
  height: 32,
  rx: 8,
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9999 11.3966L20.5299 23.0766C20.3399 23.9066 19.8499 24.0766 19.1599 23.7166L15.3699 20.9466L13.5399 22.6966C13.4499 22.8115 13.3343 22.9039 13.2024 22.9664C13.0705 23.0289 12.9258 23.0598 12.7799 23.0566L13.0599 19.2266L20.0599 12.9266C20.3699 12.6566 19.9999 12.5066 19.5899 12.7766L10.9099 18.2066L7.18989 17.0466C6.37989 16.7966 6.35989 16.2366 7.35989 15.8566L21.9999 10.2566C22.1224 10.19 22.2611 10.1589 22.4004 10.1667C22.5397 10.1746 22.674 10.2211 22.7883 10.3011C22.9025 10.3811 22.9922 10.4914 23.0473 10.6195C23.1023 10.7477 23.1206 10.8887 23.0999 11.0266C23.0775 11.1527 23.0441 11.2765 22.9999 11.3966Z",
  fill: "#d4c3da"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_776_529"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.396484,
  width: 32,
  height: 32,
  rx: 8,
  fill: "white"
})));

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.e18c46fc.svg";
export { ForwardRef as ReactComponent };